import { useLayoutEffect } from 'react';
import { ThemeType, useThemeStore } from './useStore';

export default function useSetThemeEffect(theme: ThemeType) {
  const setTheme = useThemeStore((e) => e.setTheme);

  useLayoutEffect(() => {
    setTheme(theme);
  }, [theme, setTheme]);
}
